import { ModalControl } from '../controls/ModalControl';
import { ModalAttachment } from '../dom/ModalAttachment';
import { ModalPortal } from '../dom/ModalPortal';

/**
 * // Class Obj: モーダルウィンドウの状態（表示、非表示）を管理
 * // Note:
 * // - 開く / 閉じる状態の変更だけを担当します。
 * // - イベント登録や表示内容の描画は行いません。
 */
export class ModalState
{
  private readonly mModalAttachment: ModalAttachment;
  private readonly mModalControl: ModalControl;
  private readonly mModalPortal: ModalPortal;

  private mIsWindowOpen: boolean = false;
  private mLastOpenElement: HTMLElement | null = null;

  constructor(modal_attachment: ModalAttachment, modal_control: ModalControl, modal_portal: ModalPortal)
  {
    this.mModalAttachment = modal_attachment;
    this.mModalControl = modal_control;
    this.mModalPortal = modal_portal;
  }

  /**
   * // Method: 指定要素に紐づくモーダルを開く
   * // Note:
   * // - 開く対象は data-modal-target から取得します。
   * // - 開く前に対象モーダルを body 直下へ portal 化します。
   */
  public openByElement(element: HTMLElement): void
  {
    const target_modal: HTMLElement | null = this.mModalControl.getTargetModalByElement(element);

    if (!target_modal)
    {
      return;
    }

    this.mLastOpenElement = element;

    this.mModalPortal.portal(target_modal);
    this.mModalControl.changeWindowByElement(element);

    this.mModalAttachment.toggleOverlay(true);
    this.mModalAttachment.toggleScrollBody(false);

    this.mIsWindowOpen = true;
  }

  /**
   * // Method: 開いているモーダルをすべて閉じる
   * // Note:
   * // - overlay / bodyスクロール / portal 復帰をまとめて処理します。
   * // - 最後に開いた要素へ focus を戻します。
   */
  public closeAll(): void
  {
    if (!this.mIsWindowOpen)
    {
      return;
    }

    this.mModalControl.hideAllModals();

    this.mModalAttachment.toggleOverlay(false);
    this.mModalAttachment.toggleScrollBody(true);

    this.mModalPortal.restoreAll(this.mModalControl.getAllModals());

    this.mIsWindowOpen = false;

    this.mLastOpenElement?.focus();
    this.mLastOpenElement = null;
  }
}
